import { useCallback, useState } from 'react'

import { Text } from '@wartek-id/text-v1'

import FilterButtons from 'app/KinerjaShared/components/FilterButtons'
import { Header } from 'app/KinerjaShared/components/Header'
import TablePelaksanaanPS from './TablePelaksanaanPS'
import useBasePath from 'app/KinerjaTimPenilaiPSPage/hooks/useBasePath'
import usePelaksanaanList from 'app/KinerjaTimPenilaiPSPage/hooks/usePelaksanaanList'

import type {
  PelaksanaanPSListFilterState,
  TPelaksanaanPSListSummary,
} from 'types/kinerja-tim-penilai-ps'

const FILTER_STATE: Record<PelaksanaanPSListFilterState, string> = {
  SEMUA: 'Semua',
  SELESAI_PRAKTIK_KINERJA: 'Selesai Praktik Kinerja',
  SELESAI_PERILAKU_KERJA: 'Selesai Perilaku Kerja',
  SELESAI_PENGEMBANGAN_KOMPETENSI: 'Selesai Pengembangan Kompetensi',
  SELESAI_SEMUA_KEGIATAN: 'Selesai Semua',
}

const mapping: Record<
  PelaksanaanPSListFilterState,
  keyof TPelaksanaanPSListSummary
> = {
  SEMUA: 'total',
  SELESAI_PRAKTIK_KINERJA: 'selesaiPraktikKinerja',
  SELESAI_PERILAKU_KERJA: 'selesaiPerilakuKerja',
  SELESAI_PENGEMBANGAN_KOMPETENSI: 'selesaiPengembanganKompetensi',
  SELESAI_SEMUA_KEGIATAN: 'selesaiSemuaKegiatan',
}

export default function DaftarPenilaianPelaksanaanPS() {
  const { basePath } = useBasePath()

  const [activeFilterState, setActiveFilterState] =
    useState<PelaksanaanPSListFilterState>('SEMUA')
  const { summary, data, isLoading, isFetched } = usePelaksanaanList({
    filter: activeFilterState,
  })

  const handleStateChange = useCallback(
    (state: PelaksanaanPSListFilterState) => {
      setActiveFilterState(state)
    },
    []
  )

  return (
    <div className="py-6 px-24 max-w-7xl m-auto">
      <Header title="Penilaian Kinerja" className="mt-6" />
      <div className="bg-white mt-12 border-gray-30 border rounded">
        <div className="space-y-1 px-8 py-6">
          <Text variant="heading-md" as="h2">
            Lakukan penilaian untuk Praktik Kinerja dan Perilaku Kerja
          </Text>
          <Text color="subdued">
            Cek status dari masing-masing kegiatan, termasuk status pengumpulan
            dokumen.
          </Text>
        </div>

        <div className="p-4">
          {isFetched && (
            <FilterButtons
              activeValue={activeFilterState}
              className="flex-wrap"
              onChange={handleStateChange}
              items={Object.keys(FILTER_STATE).map((state) => ({
                label: `${FILTER_STATE[state]} (${
                  summary[mapping[state as keyof typeof mapping]]
                })`,
                value: state as PelaksanaanPSListFilterState,
              }))}
            />
          )}
        </div>

        <TablePelaksanaanPS
          basePath={basePath}
          data={data?.data ?? []}
          isLoading={isLoading}
        />
      </div>
    </div>
  )
}
